var viewer_rtlignore_default = {
  "gallery_container": "Kx6JK",
  "imageTitleContainer": "Bnjl6",
  "clickableItem": "zCJs7",
  "prerender": "_5u7wE",
  "expandButton": "UNntp",
  "itemContainer": "qyMK0",
  "expandIcon": "iDL4-",
  "itemOverlay": "a5Zgd",
  "imageTitle": "n-bPy",
  "pointer": "ZZNIv",
  "fadeIn": "ciHdB",
  "changing_background": "wUTXO"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
